import Select from 'react-select'
import {useController} from 'react-hook-form'
import {Field, Label} from '@headlessui/react'
import {useState} from 'react'

import {CountryCodeEnum} from '@sdox/api'
import {Toggle} from '@sdox/ui'

import type {OnChangeValue} from 'react-select'

type CountryCodeOption = {
  value: CountryCodeEnum | '__all'
  label: string
  isDisabled?: boolean
}

const allCountriesOption: CountryCodeOption = {value: '__all', label: 'Alle Länder', isDisabled: true}

const countryCodeOptions: CountryCodeOption[] = [
  {value: CountryCodeEnum.De, label: 'Deutschland'},
  {value: CountryCodeEnum.At, label: 'Österreich'},
]

type MetaFormValues = {
  meta: {
    pullout: boolean
    countryCodes: CountryCodeEnum[]
  }
}

export const CountryCodeInput = () => {
  const {field: {value, onChange: setValue}} = useController<MetaFormValues>({name: 'meta.countryCodes'})
  const valueAsArray: CountryCodeEnum[] = Array.isArray(value) ? value : []
  const internalValue: CountryCodeOption[] = valueAsArray
    .map(value => countryCodeOptions.find(option => option.value === value))
    .filter((value): value is CountryCodeOption => Boolean(value))

  const [isExtended, setIsExtended] = useState(internalValue.length !== 0)

  const options: CountryCodeOption[] = [
    {...allCountriesOption, isDisabled: internalValue.length === 0},
    ...countryCodeOptions,
  ]

  const onChange = (newValue: OnChangeValue<CountryCodeOption, true>) => {
    if (newValue.find(option => option.value === allCountriesOption.value) !== undefined) {
      setValue([])
      return
    }
    setValue(newValue.map(option => option.value))
  }

  return (
    <div className={'mt-spacing-12'}>
      <Field className={'flex justify-between'}>
        <Label className={'cursor-pointer'}>Erweiterte Einstellungen</Label>
        <Toggle
          checked={isExtended}
          onChange={setIsExtended}
        />
      </Field>
      {isExtended ? (
        <div className={'mt-spacing-12 bg-surface-secondary p-spacing-12'}>
          <label htmlFor={'countryCodes'}>
            Länder:
          </label>
          <Select
            id={'countryCodes'}
            isMulti={true}
            value={internalValue}
            options={options}
            onChange={onChange}
            placeholder={'Alle Länder'}
          />
          <small>In diesen Ländern wird der Block angezeigt.</small>
        </div>
      ) : null}
    </div>
  )
}
